import { render, staticRenderFns } from "./TemplatesSidebar.vue?vue&type=template&id=3a23b8ae&scoped=true"
import script from "./TemplatesSidebar.vue?vue&type=script&lang=js"
export * from "./TemplatesSidebar.vue?vue&type=script&lang=js"
import style0 from "./TemplatesSidebar.vue?vue&type=style&index=0&id=3a23b8ae&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a23b8ae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a23b8ae')) {
      api.createRecord('3a23b8ae', component.options)
    } else {
      api.reload('3a23b8ae', component.options)
    }
    module.hot.accept("./TemplatesSidebar.vue?vue&type=template&id=3a23b8ae&scoped=true", function () {
      api.rerender('3a23b8ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/templates/TemplatesSidebar.vue"
export default component.exports